import React from 'react';

const About = () => {
  return (
    <section id="about" className="py-16 sm:py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-logo-navy mb-4">Company Overview</h2>
          <p className="text-gray-600 max-w-3xl mx-auto text-base sm:text-lg">
            Adapt Technology Solutions partners with small and mid-sized businesses to design and manage technology strategies aligned with business growth. We bridge the gap between technical operations and executive decision-making.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
          <div className="bg-gradient-to-br from-blue-50 to-logo-lightblue/10 p-6 sm:p-8 rounded-xl border border-blue-100">
            <div className="w-12 h-12 sm:w-14 sm:h-14 gradient-blue rounded-lg flex items-center justify-center mb-4 sm:mb-6">
              <i className="fas fa-eye text-white text-xl sm:text-2xl"></i>
            </div>
            <h3 className="text-lg sm:text-xl font-bold text-logo-navy mb-2 sm:mb-3">Vision</h3>
            <p className="text-gray-600 text-sm sm:text-base">
              To empower businesses through intelligent, secure, and scalable technology.
            </p>
          </div>
          
          <div className="bg-gradient-to-br from-green-50 to-logo-green/10 p-6 sm:p-8 rounded-xl border border-green-100">
            <div className="w-12 h-12 sm:w-14 sm:h-14 gradient-green rounded-lg flex items-center justify-center mb-4 sm:mb-6">
              <i className="fas fa-bullseye text-white text-xl sm:text-2xl"></i>
            </div>
            <h3 className="text-lg sm:text-xl font-bold text-logo-navy mb-2 sm:mb-3">Mission</h3>
            <p className="text-gray-600 text-sm sm:text-base">
              Deliver strategic IT consulting, cybersecurity, cloud solutions, and project leadership that ensures long-term success.
            </p>
          </div>
          
          <div className="bg-gradient-to-br from-teal-50 to-logo-teal/10 p-6 sm:p-8 rounded-xl border border-teal-100">
            <div className="w-12 h-12 sm:w-14 sm:h-14 bg-gradient-to-r from-logo-teal to-logo-green3 rounded-lg flex items-center justify-center mb-4 sm:mb-6">
              <i className="fas fa-gem text-white text-xl sm:text-2xl"></i>
            </div>
            <h3 className="text-lg sm:text-xl font-bold text-logo-navy mb-2 sm:mb-3">Values</h3>
            <ul className="text-gray-600 text-sm sm:text-base space-y-1">
              <li>• Integrity & Accountability</li>
              <li>• Innovation & Excellence</li>
              <li>• Client-Centered Service</li>
              <li>• Security & Trust</li>
              <li>• Continuous Improvement</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;